// extracted by mini-css-extract-plugin
export default {"error":"EventPage_error__39z9E"};